import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import createPersistedStaste from 'vuex-persistedstate'
const apiUrl = "https://gn3bbxdche.execute-api.us-west-2.amazonaws.com/Production/api";
const apiDev = "https://gn3bbxdche.execute-api.us-west-2.amazonaws.com/sandbox/api";
//change for production club-prod; club-qa for dev
const apiClub = "https://gn3bbxdche.execute-api.us-west-2.amazonaws.com/club-prod/api";

import developmentModule from "./development";
import financialModule from "./financial";
import functionsModule from "./functions";
import infoMessageModule from "./info_message"
import sheetDocument from "./sheet_document";
import AnniversaryClubGolfModule from "./AnniversaryClubGolfModule"

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedStaste()],
  state: {
  },
  getters: {
    api(){
      return Axios.create({
            baseURL: apiUrl
      });
    },
    apiDev(){
      return Axios.create({
          baseURL: apiDev
      });
    },
    apiClub(){
      return Axios.create({
        baseURL: apiClub
      });
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    development: developmentModule,
    financial: financialModule,
    functions: functionsModule,
    info_message: infoMessageModule,
    sheet_document: sheetDocument,
    AnniversaryClubGolfModule: AnniversaryClubGolfModule
  }
})
